export enum LocalStorageKeys {
  FAVORITES = "favorites",
}
